const translations = {
  'contacto.seo.title': 'Thinking of Teaching English in Barcelona? Contact us',
  'contacto.seo.description': `Thinking of teaching English in Barcelona? Contact us to find out more and we'll get back to you in under 24 hours.`,
  'contacto.sec1.title': 'Contact Us',
  'contacto.sec1.description': 'We will reply to your enquiry within 24 hours.',

  'contacto.sec2.form': 'Send Us A Message',
  'contacto.sec2.firstName': 'First Name',
  'contacto.sec2.lastName': 'Last Name',
  'contacto.sec2.email': 'Email',
  'contacto.sec2.comment': 'Questions / Comments',
  'contacto.sec2.submit': 'Submit',

  'contacto.sec2.text':
    'TEFL Iberia is centrally located in the elegant Eixample neighbourhood, only 2 minutes walking from Passeig de Gracia and 10 minutes to Plaza Catalunya.',
  'contacto.sec2.address': 'ADDRESS:',
  'contacto.sec2.hours': 'RECEPTION HOURS:',
  'contacto.sec2.phone': 'Phone:',
  'contacto.sec2.whatsapp': 'Whatsapp:',
  'contacto.sec2.email': 'Email:',
};

export default translations;
